module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/main-view_4cabbc1740f59ddabebc2edca68fb572.png";